import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { STATUSES } from "../globals/misc/statuses";
import { registerUser } from "../store/authSlice";

const Register = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    password: "",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.auth);
  const loading = status === STATUSES.LOADING;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ok = await dispatch(registerUser(formData));
    if (ok) navigate("/login");
  };

  return (
    <div className="relative flex min-h-[80vh] items-center justify-center px-4 py-16">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(245,158,11,0.14),_transparent_55%)]" />
      <div className="relative w-full max-w-md animate-rise">
        <div className="mb-8 text-center">
          <p className="mb-2 text-sm font-semibold uppercase tracking-[0.2em] text-amber-600">
            Join the community
          </p>
          <h1 className="font-display text-4xl font-bold text-navy-900">
            Create account
          </h1>
          <p className="mt-2 text-navy-800/70">
            Report hazards and push for safer roads.
          </p>
        </div>

        <div className="rounded-2xl border border-navy-900/10 bg-white/90 p-8 shadow-[0_20px_60px_rgba(11,31,68,0.08)] backdrop-blur">
          <form className="space-y-5" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="name" className="mb-1.5 block text-sm font-medium text-navy-900">
                Full name
              </label>
              <input
                id="name"
                name="name"
                type="text"
                required
                minLength={2}
                value={formData.name}
                onChange={handleChange}
                className="w-full rounded-xl border border-navy-900/15 bg-surface px-4 py-2.5 outline-none transition focus:border-navy-700 focus:ring-2 focus:ring-navy-700/20"
              />
            </div>

            <div>
              <label htmlFor="email" className="mb-1.5 block text-sm font-medium text-navy-900">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                value={formData.email}
                onChange={handleChange}
                className="w-full rounded-xl border border-navy-900/15 bg-surface px-4 py-2.5 outline-none transition focus:border-navy-700 focus:ring-2 focus:ring-navy-700/20"
              />
            </div>

            <div>
              <label htmlFor="phoneNumber" className="mb-1.5 block text-sm font-medium text-navy-900">
                Phone number
              </label>
              <input
                id="phoneNumber"
                name="phoneNumber"
                type="tel"
                required
                value={formData.phoneNumber}
                onChange={handleChange}
                className="w-full rounded-xl border border-navy-900/15 bg-surface px-4 py-2.5 outline-none transition focus:border-navy-700 focus:ring-2 focus:ring-navy-700/20"
              />
            </div>

            <div>
              <label htmlFor="password" className="mb-1.5 block text-sm font-medium text-navy-900">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                minLength={8}
                value={formData.password}
                onChange={handleChange}
                className="w-full rounded-xl border border-navy-900/15 bg-surface px-4 py-2.5 outline-none transition focus:border-navy-700 focus:ring-2 focus:ring-navy-700/20"
              />
              <p className="mt-1 text-xs text-navy-800/60">At least 8 characters</p>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-xl bg-amber-500 py-3 text-sm font-semibold text-navy-950 transition hover:bg-amber-400 disabled:cursor-not-allowed disabled:opacity-70"
            >
              {loading ? "Creating account..." : "Create account"}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-navy-800/70">
            Already have an account?{" "}
            <Link to="/login" className="font-semibold text-navy-800 hover:text-navy-900">
              Sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
